/* DROP theme: shared behaviour (panels, bag, search, menus, image fit, rails, motion) */
(() => {
  const CFG = window.DROP_CFG || { t: {} };
  const DROP = (window.DROP = window.DROP || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  DROP.$ = $; DROP.$$ = $$;
  DROP.esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const withParam = (url, k, v) => url + (url.includes('?') ? '&' : '?') + k + '=' + encodeURIComponent(v);
  DROP.withParam = withParam;
  DROP.section = (url, id) => fetch(withParam(url, 'section_id', id), { credentials: 'same-origin' }).then(r => (r.ok ? r.text() : Promise.reject(r.status)));
  DROP.parse = html => { const d = document.createElement('div'); d.innerHTML = html; return d; };

  /* image fit: read each product photo's edge colour and pick one consistent treatment.
     white cut out: floats on the card; plain colour backdrop: card takes that colour; real photo: fills the card */
  const FIT_KEY = 'drop-fit-v1';
  let fitStore = {}; try { fitStore = JSON.parse(localStorage.getItem(FIT_KEY) || '{}'); } catch (e) { }
  const fitCache = new Map(Object.entries(fitStore));
  let fitSaveT;
  const fitSave = () => { clearTimeout(fitSaveT); fitSaveT = setTimeout(() => { try { const o = Object.fromEntries([...fitCache].slice(-900)); localStorage.setItem(FIT_KEY, JSON.stringify(o)); } catch (e) { } }, 1500); };
  const fitKey = src => (src || '').split('?')[0];
  DROP.fitRead = img => {
    try {
      const c = document.createElement('canvas'), n = 40; c.width = c.height = n;
      const x = c.getContext('2d', { willReadFrequently: true });
      x.fillStyle = '#fff'; x.fillRect(0, 0, n, n); x.drawImage(img, 0, 0, n, n);
      const d = x.getImageData(0, 0, n, n).data, px = [];
      for (let y = 0; y < n; y++) for (let i = 0; i < n; i++) if (i < 2 || i > n - 3 || y < 2 || y > n - 3) { const k = (y * n + i) * 4; px.push([d[k], d[k + 1], d[k + 2]]); }
      const avg = [0, 1, 2].map(j => px.reduce((s, p) => s + p[j], 0) / px.length);
      const near = px.filter(p => Math.hypot(p[0] - avg[0], p[1] - avg[1], p[2] - avg[2]) < 24).length / px.length;
      if (near < 0.9) return { kind: 'photo' };
      if (Math.min(...avg) > 248) {
        let x0 = n, y0 = n, x1 = -1, y1 = -1;
        for (let y = 0; y < n; y++) for (let i = 0; i < n; i++) { const k = (y * n + i) * 4; if (Math.min(d[k], d[k + 1], d[k + 2]) < 244) { x0 = Math.min(x0, i); y0 = Math.min(y0, y); x1 = Math.max(x1, i); y1 = Math.max(y1, y); } }
        if (x1 - x0 > 10 && y1 - y0 > 10) {
          const ring = []; for (let y = y0 + 1; y < y1; y++) for (let i = x0 + 1; i < x1; i++) if (i === x0 + 1 || i === x1 - 1 || y === y0 + 1 || y === y1 - 1) { const k = (y * n + i) * 4; ring.push([d[k], d[k + 1], d[k + 2]]); }
          const ra = [0, 1, 2].map(j => ring.reduce((s, p) => s + p[j], 0) / ring.length);
          const rn = ring.filter(p => Math.hypot(p[0] - ra[0], p[1] - ra[1], p[2] - ra[2]) < 24).length / ring.length;
          if (rn > 0.85 && Math.min(...ra) < 244) return { kind: 'framed', box: [(x0 + 1) / n, (y0 + 1) / n, x1 / n, y1 / n] };
        }
        return { kind: 'white' };
      }
      const bg = `rgb(${avg.map(Math.round).join(',')})`;
      return Math.min(...avg) > 215 ? { kind: 'light', bg } : { kind: 'flat', bg };
    } catch (e) { return null; }
  };
  DROP.fitApply = img => {
    const key = fitKey(img.currentSrc || img.src); if (!key || !img.naturalWidth) return;
    let r = fitCache.get(key); if (r === undefined) { r = DROP.fitRead(img); fitCache.set(key, r); fitSave(); }
    img.classList.remove('fit-white', 'fit-light', 'fit-flat', 'fit-photo'); img.style.backgroundColor = '';
    const host = img.hasAttribute('data-fit-parent') ? img.parentElement : null; if (host) host.style.backgroundColor = '';
    if (!r) return;
    if (r.kind === 'framed') {
      /* a white margin around a coloured photo: zoom the photo to fill the frame (cover slots) */
      if (getComputedStyle(img).objectFit !== 'cover') { img.classList.add('fit-white'); return; }
      const ratio = img.naturalWidth / img.naturalHeight || 1;
      const mapX = x => (ratio > 1 ? (x - 0.5) * ratio + 0.5 : x), mapY = y => (ratio < 1 ? (y - 0.5) / ratio + 0.5 : y);
      const [bx0, by0, bx1, by1] = r.box, X0 = mapX(bx0), X1 = mapX(bx1), Y0 = mapY(by0), Y1 = mapY(by1);
      const sc = Math.min(3, 1 / Math.max(X1 - X0, Y1 - Y0));
      const fx = (-((X0 + X1) / 2 - 0.5) * sc * 100).toFixed(2) + '%', fy = (-((Y0 + Y1) / 2 - 0.5) * sc * 100).toFixed(2) + '%';
      img.style.setProperty('--fs', sc.toFixed(3)); img.style.setProperty('--fx', fx); img.style.setProperty('--fy', fy);
      if (!img.closest('.card__media')) img.style.transform = `translate(${fx},${fy}) scale(${sc.toFixed(3)})`;
      img.classList.add('fit-photo'); return;
    }
    img.classList.add('fit-' + r.kind);
    if (r.bg) { img.style.backgroundColor = r.bg; if (host) host.style.backgroundColor = r.bg; }
    if (host && r.kind === 'white') host.style.backgroundColor = 'var(--paper)';
  };
  /* reading photos runs in idle time so it never blocks scrolling or taps; known photos apply at once */
  const fitQueue = [];
  const idle = cb => ('requestIdleCallback' in window ? requestIdleCallback(cb, { timeout: 600 }) : setTimeout(() => cb({ timeRemaining: () => 8, didTimeout: true }), 60));
  let fitBusy = false;
  const fitPump = dl => {
    while (fitQueue.length && (dl.timeRemaining() > 3 || dl.didTimeout)) { const im = fitQueue.shift(); if (im.isConnected) DROP.fitApply(im); if (dl.didTimeout) break; }
    if (fitQueue.length) idle(fitPump); else fitBusy = false;
  };
  const touch = matchMedia('(hover:none)').matches;
  const fitLater = img => {
    if (fitCache.has(fitKey(img.currentSrc || img.src))) { DROP.fitApply(img); return; }
    fitQueue.push(img); if (!fitBusy) { fitBusy = true; idle(fitPump); }
  };
  DROP.fitWatch = img => {
    if (img._fit) return; img._fit = 1;
    if (touch && img.classList.contains('alt') && img.closest('.card__media')) return;
    img.addEventListener('load', () => { img.style.visibility = ''; fitLater(img); });
    img.addEventListener('error', () => { img.style.visibility = 'hidden'; });
    if (img.complete) img.naturalWidth ? fitLater(img) : img.getAttribute('src') && (img.style.visibility = 'hidden');
  };
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType !== 1) return; if (n.matches('img[data-fit]')) DROP.fitWatch(n); n.querySelectorAll?.('img[data-fit]').forEach(DROP.fitWatch); }))).observe(document.documentElement, { childList: true, subtree: true });
  $$('img[data-fit]').forEach(DROP.fitWatch);

  /* panels: bag, menu, search, filters, size guide */
  let lastFocus = null;
  DROP.open = id => {
    $$('.drawer.on,.search.on').forEach(d => d.classList.remove('on'));
    const el = document.getElementById(id); if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('on'); $('#overlay')?.classList.add('on');
    document.body.style.overflow = 'hidden';
    if (id === 'search') { DROP.searchInit(); setTimeout(() => el.querySelector('input[type=search]')?.focus(), 300); }
    else setTimeout(() => ($('.qa__sizes button:not([disabled])', el) && id === 'qa' ? $('.qa__sizes button:not([disabled])', el) : el).focus({ preventScroll: true }), 50);
  };
  DROP.close = () => {
    const was = $$('.drawer.on,.search.on'); if (!was.length) return;
    was.forEach(d => d.classList.remove('on'));
    $('#overlay')?.classList.remove('on'); document.body.style.overflow = '';
    if (lastFocus && lastFocus !== document.body && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    if (document.activeElement?.closest('.drawer,.search')) document.activeElement.blur();
  };
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); DROP.open(o.dataset.open); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'overlay') DROP.close();
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') DROP.close();
    if (e.key === '/' && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) { e.preventDefault(); DROP.open('search'); }
  });

  /* toast */
  let toastT;
  DROP.toast = info => {
    const t = $('#toast'); if (!t) return;
    const size = info.size ? ' · ' + DROP.esc(/^one ?size$/i.test(info.size) ? 'One size' : (CFG.t.size || 'Size') + ' ' + info.size) : '';
    t.innerHTML = info.error
      ? `<div><p class="meta" style="color:var(--signal)">${DROP.esc(CFG.t.not_added || 'Not added')}</p><p>${DROP.esc(info.error)}</p></div>`
      : `${info.img ? `<img data-fit crossorigin="anonymous" src="${DROP.esc(info.img)}" alt="">` : ''}<div><p class="meta" style="color:var(--ink-soft)">${DROP.esc(CFG.t.added || 'Added to bag')}${size}</p><p>${DROP.esc([info.brand, info.title].filter(Boolean).join(' '))}</p></div><button class="link" type="button" data-open="cart" style="color:#fff">${DROP.esc(CFG.t.view_bag || 'View bag')}</button>`;
    t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 4500);
    t.onmouseenter = () => clearTimeout(toastT); t.onmouseleave = () => { toastT = setTimeout(() => t.classList.remove('on'), 2000); };
    t.onclick = e => { if (e.target.closest('[data-open]')) t.classList.remove('on'); };
  };

  /* bag: Shopify cart with the drawer re-rendered by the Section Rendering API */
  /* Shopify's cart messages, in the DROP voice */
  const friendly = msg => {
    const m = String(msg || '');
    if (/maximum quantity|already in your cart|are in your cart|can only add|only \d+ (of this )?item|can't add more|cannot add more/i.test(m)) return CFG.t.max || m;
    if (/sold out|not available|unavailable/i.test(m)) return CFG.t.sold || m;
    return m || CFG.t.error;
  };
  const cartSections = () => ['cart-drawer', ...$$('[data-cart-section]').map(el => el.dataset.cartSection)].join(',');
  DROP.cart = {
    apply(sections) {
      if (!sections) return;
      const html = sections['cart-drawer'];
      if (html) {
        const d = DROP.parse(html);
        const act = document.activeElement, keep = act?.closest('#cart') && act.matches('[data-q]') ? [act.dataset.q, act.getAttribute('aria-label') || act.textContent.trim()] : null;
        ['#cart-bd', '#cart-ft', '#cart-n'].forEach(sel => { const fresh = $(sel, d), old = $(sel); if (fresh && old) old.replaceWith(fresh); });
        const n = +($('#cart-n')?.dataset.count || 0);
        $$('.bag-count').forEach(el => {
          const was = +el.dataset.n || 0; el.textContent = n || ''; el.dataset.n = n;
          if (n > was) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
        });
        if (keep) ($$('#cart [data-q]').find(b => b.dataset.q === keep[0] && (b.getAttribute('aria-label') || b.textContent.trim()) === keep[1]) || $('#cart'))?.focus({ preventScroll: true });
      }
      $$('[data-cart-section]').forEach(el => {
        const h = sections[el.dataset.cartSection]; if (!h) return;
        const fresh = $('[data-cart-section]', DROP.parse(h)); if (fresh) el.replaceWith(fresh);
      });
      DROP.motion();
      document.dispatchEvent(new CustomEvent('cart:change'));
    },
    /* optimistic: the count, the confirmation and the toast show at once; a refusal from Shopify rolls them back */
    async add(id, qty = 1, info = {}) {
      const items = Array.isArray(id) ? id : [{ id: +id, quantity: qty }];
      const n = items.reduce((a, i) => a + (+i.quantity || 1), 0);
      DROP.count(n); DROP.toast(info);
      const root = document.documentElement; root.dataset.adding = (+root.dataset.adding || 0) + 1;
      let r, data = {};
      try {
        r = await fetch(CFG.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: cartSections(), sections_url: location.pathname }) });
        data = await r.json().catch(() => ({}));
      } catch (e) { r = null; }
      const left = (+root.dataset.adding || 1) - 1; if (left) root.dataset.adding = left; else delete root.dataset.adding;
      if (!r || !r.ok) { DROP.count(-n, true); DROP.toast({ error: friendly(data.description || data.message) }); return false; }
      DROP.cart.apply(data.sections);
      return true;
    },
    async change(line, quantity) {
      let r, data = {};
      try {
        r = await fetch(CFG.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +line, quantity: +quantity, sections: cartSections(), sections_url: location.pathname }) });
        data = await r.json().catch(() => ({}));
      } catch (e) { r = null; }
      if (!r || !r.ok) { DROP.toast({ error: friendly(data.description || data.message) }); return; }
      DROP.cart.apply(data.sections);
    },
  };
  DROP.count = (d, quiet) => $$('.bag-count').forEach(el => {
    const n = Math.max(0, (+el.dataset.n || 0) + d); el.dataset.n = n; el.textContent = n || '';
    if (!quiet && d > 0) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  });
  DROP.infoFrom = el => {
    const card = el.closest('.card,.stl__item,.look__item,[data-product-info]');
    if (!card) return {};
    if (card.dataset.productInfo) { try { return JSON.parse(card.dataset.productInfo); } catch (e) { return {}; } }
    const img = card.querySelector('img');
    return { brand: card.querySelector('.card__brand')?.textContent.trim(), title: card.querySelector('.card__title')?.textContent.trim(), img: img?.currentSrc || img?.src };
  };
  let cartBusy = false;
  document.addEventListener('click', async e => {
    const quick = e.target.closest('[data-quick]');
    if (quick) { e.preventDefault(); DROP.quick(quick.closest('.card')); return; }
    const add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault(); if (add.disabled || add.dataset.busy) return;
      add.dataset.busy = 1; DROP.added(add);
      let ok = false;
      try { ok = await DROP.cart.add(add.dataset.add, 1, { ...DROP.infoFrom(add), size: add.dataset.size || '' }); } finally { delete add.dataset.busy; }
      if (!ok) DROP.unadded(add);
      return;
    }
    const q = e.target.closest('[data-q]');
    if (q) {
      /* one change at a time: the buttons carry quantities from the last render, so a second click before it refreshes would use a stale number */
      e.preventDefault(); if (cartBusy || q.disabled) return; cartBusy = true;
      const line = q.closest('.line-item'); line?.classList.add('is-busy');
      try { await DROP.cart.change(q.dataset.q, q.dataset.qty); } finally { cartBusy = false; line?.classList.remove('is-busy'); }
    }
  });

  /* quick add feedback, right where the shopper clicked */
  const check = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m5 12 4.5 4.5L19 7"/></svg>';
  DROP.added = btn => {
    if (btn.closest('#qa')) { btn.classList.add('is-added'); setTimeout(() => DROP.close(), 350); return; }
    const panel = btn.closest('.card__quick');
    if (panel) {
      const m = $('.meta', panel); panel.classList.add('is-added'); btn.classList.add('is-added');
      m.textContent = (CFG.t.added || 'Added to bag') + (btn.dataset.size ? ' · ' + btn.dataset.size : '');
      clearTimeout(panel._t); panel._t = setTimeout(() => { panel.classList.remove('is-added'); btn.classList.remove('is-added'); m.textContent = m.dataset.label; }, 1800);
      return;
    }
    if (btn.classList.contains('card__add')) {
      clearTimeout(btn._t); if (!btn._html) btn._html = btn.innerHTML;
      btn.classList.add('is-added'); btn.innerHTML = check;
      btn._t = setTimeout(() => { btn.classList.remove('is-added'); btn.innerHTML = btn._html; }, 1600);
      return;
    }
    btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1400);
  };
  DROP.unadded = btn => {
    btn.classList.remove('is-added'); if (btn._html) { clearTimeout(btn._t); btn.innerHTML = btn._html; }
    const panel = btn.closest('.card__quick'); if (panel) { clearTimeout(panel._t); panel.classList.remove('is-added'); $('.meta', panel).textContent = $('.meta', panel).dataset.label; }
  };
  /* touch screens: the + button opens a size sheet built from the card */
  DROP.quick = card => {
    const qa = $('#qa'); if (!qa || !card) return;
    const bd = $('.qa__bd', qa), img = $('.card__media img.main', card), info = $('.card__info', card), link = $('.card__link', card);
    const brand = $('.card__brand', info)?.textContent.trim() || '', title = $('.card__title', info)?.textContent.trim() || '';
    const src = img ? img.currentSrc || img.src : '';
    bd.dataset.productInfo = JSON.stringify({ brand, title, img: src });
    bd.innerHTML = `<div class="qa__item">${src ? `<img src="${DROP.esc(src)}" alt="">` : '<span></span>'}<div class="card__info"><span class="card__brand">${DROP.esc(brand)}</span><span class="card__title">${DROP.esc(title)}</span><span class="price">${$('.price', info)?.innerHTML || ''}</span></div></div>`
      + `<div class="qa__sizes">${$$('.card__sizes button', card).map(b => `<button type="button" data-add="${b.dataset.add}" data-size="${DROP.esc(b.dataset.size)}"${b.disabled ? ' disabled' : ''}>${DROP.esc(b.textContent.trim())}</button>`).join('')}</div>`
      + `<a class="link qa__more" href="${link?.href || '#'}">${DROP.esc(CFG.t.details || 'View full details')}</a>`;
    DROP.open('qa');
  };

  /* intro: once per visit. D, R, O rise, the P drops in, then the curtain lifts */
  DROP.intro = async () => {
    const root = document.documentElement;
    if (!root.classList.contains('intro')) return;
    try { sessionStorage.setItem('drop-intro', '1'); } catch (e) { }
    const tpl = $('#logo-tpl'); if (!tpl) { root.classList.remove('intro'); return; }
    const el = document.createElement('div');
    el.className = 'intro-c'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = tpl.innerHTML.replace(/<path /g, '<path class="ip" ');
    document.body.appendChild(el);
    root.classList.remove('intro');
    $$('.ip', el).forEach((p, i) => p.style.setProperty('--i', [0, 1, 3, 2][i]));
    requestAnimationFrame(() => el.classList.add('go'));
    await new Promise(res => { const t = setTimeout(res, 1000); el.addEventListener('click', () => { clearTimeout(t); res(); }, { once: true }); });
    el.classList.add('out');
    setTimeout(() => el.remove(), 560);
  };

  /* header: transparent over the hero until you scroll, menus load on first use */
  const hdr = () => $('#hdr');
  const bindMega = (m, li) => {
    const pv = $('.mega__pv', m); if (!pv) return;
    const def = $('.mega__def', pv), show = $('.mega__show', pv), im = $('img', show);
    let warmed = false;
    const warm = () => { if (warmed) return; warmed = true; $$('a[data-pv]', m).forEach(x => { const i = new Image(); i.src = x.dataset.pv; }); };
    li.addEventListener('mouseenter', warm); if (li.matches(':hover')) warm();
    $$('a[data-pv]', m).forEach(a => a.addEventListener('mouseenter', () => {
      if (im.getAttribute('src') !== a.dataset.pv) { im.style.opacity = 0; im.onload = () => (im.style.opacity = 1); im.src = a.dataset.pv; if (im.complete && im.naturalWidth) im.style.opacity = 1; }
      im.classList.toggle('prod', a.dataset.pvProd === '1');
      show.href = a.href; $('.h3', show).textContent = a.dataset.pvT; $('.meta', show).textContent = a.dataset.pvM || '';
      def.hidden = true; show.hidden = false;
      $$('a[data-pv].on', m).forEach(x => x.classList.remove('on')); a.classList.add('on');
    }));
    m.addEventListener('mouseleave', () => { def.hidden = false; show.hidden = true; $$('a[data-pv].on', m).forEach(x => x.classList.remove('on')); });
  };
  const megaLoad = li => li._mega || (li._mega = DROP.section(li.dataset.mega, 'mega-menu').then(html => {
    const m = $('.mega', DROP.parse(html)); if (!m || $('.mega', li)) return;
    li.appendChild(m); bindMega(m, li);
  }).catch(() => { li._mega = null; }));
  const desktop = () => matchMedia('(min-width:1101px) and (hover:hover)').matches;
  const headerInit = () => {
    const h = hdr(); if (!h || h._init) return; h._init = 1;
    if (h.classList.contains('hdr--over')) {
      const onS = () => h.classList.toggle('is-solid', scrollY > 40);
      addEventListener('scroll', onS, { passive: true }); onS();
    }
    /* hover intent: open after a short pause, close only after the pointer has really left */
    const scrim = $('#mega-scrim');
    let openLi = null, openT, closeT, switchT;
    const GRACE = 380;
    const setOpen = li => {
      if (openLi === li) return;
      const switching = !!(openLi && li);
      if (switching) { h.classList.add('mega-switch'); clearTimeout(switchT); switchT = setTimeout(() => h.classList.remove('mega-switch'), 50); }
      openLi?.classList.remove('is-open');
      openLi = li;
      li?.classList.add('is-open');
      h.classList.toggle('is-open', !!li);
      scrim?.classList.toggle('on', !!li);
    };
    const later = (fn, ms) => { clearTimeout(openT); clearTimeout(closeT); return setTimeout(fn, ms); };
    $$('.nav>li', h).forEach(li => {
      const hasMega = !!li.dataset.mega;
      li.addEventListener('pointerenter', e => {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (!hasMega) { closeT = later(() => setOpen(null), 160); return; }
        megaLoad(li);
        openT = later(() => setOpen(li), openLi ? 140 : 70);
      });
      li.addEventListener('pointerleave', e => {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (!hasMega) return;
        clearTimeout(openT);
        closeT = later(() => { if (openLi === li) setOpen(null); }, GRACE);
      });
      if (hasMega) {
        li.addEventListener('focusin', () => { megaLoad(li); clearTimeout(closeT); setOpen(li); });
        li.addEventListener('focusout', e => { if (!li.contains(e.relatedTarget)) closeT = later(() => { if (openLi === li) setOpen(null); }, 60); });
      }
    });
    scrim?.addEventListener('pointerenter', () => { closeT = later(() => setOpen(null), GRACE); });
    scrim?.addEventListener('click', () => { clearTimeout(closeT); setOpen(null); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && openLi) { const a = $('a', openLi); setOpen(null); a?.focus(); } });
    const prefetch = () => desktop() && $$('.nav>li[data-mega]', h).forEach(megaLoad);
    addEventListener('load', () => ('requestIdleCallback' in window ? requestIdleCallback(prefetch, { timeout: 4000 }) : setTimeout(prefetch, 2500)), { once: true });
  };

  /* search panel */
  let sT, sCtl;
  const runSearch = async q => {
    const out = $('#s-out'); if (!out) return;
    sCtl?.abort(); sCtl = new AbortController();
    const url = q ? `${CFG.search}?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last` : CFG.search;
    try {
      const r = await fetch(withParam(url, 'section_id', 'search-quick'), { signal: sCtl.signal });
      if (!r.ok) return;
      const d = DROP.parse(await r.text()); const inner = $('.shopify-section', d) || d;
      out.innerHTML = inner.innerHTML;
    } catch (e) { }
  };
  DROP.searchInit = () => {
    const s = $('#search'); if (!s || s._init) return; s._init = 1;
    const inp = $('input[type=search]', s);
    inp.addEventListener('input', () => { clearTimeout(sT); sT = setTimeout(() => runSearch(inp.value.trim()), 220); });
    runSearch('');
  };

  /* rails: arrows find their rail when clicked, so it does not matter which loads first */
  const ctrlOf = rail => (rail.nextElementSibling?.classList.contains('rail-ctrl') ? rail.nextElementSibling : null);
  const railOf = ctrl => (ctrl.previousElementSibling?.classList.contains('rail') ? ctrl.previousElementSibling : null);
  DROP.railSync = rail => {
    const ctrl = ctrlOf(rail); if (!ctrl) return;
    const bar = $('.rail-progress i', ctrl), max = rail.scrollWidth - rail.clientWidth;
    if (bar) { bar.style.width = Math.min(100, (rail.clientWidth / rail.scrollWidth) * 100) + '%'; bar.style.left = (rail.scrollLeft / rail.scrollWidth) * 100 + '%'; }
    const [prev, next] = $$('[data-dir]', ctrl);
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('.rail-ctrl [data-dir]'); if (!b) return;
    const rail = railOf(b.closest('.rail-ctrl')); if (!rail) return;
    const card = rail.firstElementChild, gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    const per = Math.max(1, Math.floor((rail.clientWidth + gap) / step));
    rail.scrollBy({ left: +b.dataset.dir * per * step, behavior: 'smooth' });
  });
  DROP.rail = rail => {
    rail.dataset.ready = 1;
    const sync = () => DROP.railSync(rail);
    rail.addEventListener('scroll', sync, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail); else addEventListener('resize', sync);
    new MutationObserver(sync).observe(rail, { childList: true });
    let down = false, sx, sl;
    rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; sx = e.clientX; sl = rail.scrollLeft; });
    addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 5) rail.classList.add('dragging'); rail.scrollLeft = sl - dx; });
    addEventListener('pointerup', () => { down = false; setTimeout(() => rail.classList.remove('dragging'), 0); });
    sync();
  };

  /* reveal on scroll */
  let io;
  DROP.motion = (root = document) => {
    io ||= new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px 12% 0px' });
    $$('.rv:not(.in),.split:not(.in)', root).forEach(el => io.observe(el));
    $$('.rail', root).forEach(r => (r.dataset.ready ? DROP.railSync(r) : DROP.rail(r)));
  };

  /* house style for text the theme cannot reach in Liquid (policy pages) */
  DROP.cleanText = root => {
    const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let n; (n = tw.nextNode());) n.nodeValue = n.nodeValue.replace(/(\d)\s*[-–—]\s*(\d)/g, '$1 to $2').replace(/\s+[-–—]\s+/g, ': ').replace(/\be-commerce\b/gi, 'ecommerce').replace(/(\w)[-–—](\w)/g, '$1 $2');
  };

  const boot = () => {
    DROP.introDone = DROP.intro();
    headerInit();
    $$('[data-clean]').forEach(DROP.cleanText);
    DROP.motion();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();

  /* theme editor: re-run behaviour on sections the editor re-renders */
  document.addEventListener('shopify:section:load', e => { DROP.motion(e.target); document.dispatchEvent(new CustomEvent('drop:section', { detail: e.target })); });
})();
